import produce from 'immer';
import { LOAD_PERMISSIONS_FAILURE, LOAD_PERMISSIONS_REQUEST, LOAD_PERMISSIONS_SUCCESS, LOAD_USER_FAILURE, LOAD_USER_REQUEST, LOAD_USER_SUCCESS, UPDATE_PERMISSIONS_FAILURE, UPDATE_PERMISSIONS_REQUEST, UPDATE_PERMISSIONS_SUCCESS, UPDATE_USER_FAILURE, UPDATE_USER_REQUEST, UPDATE_USER_SUCCESS, UPDATE_USER_FIRST_NAME, UPDATE_USER_LAST_NAME, } from './constants';
export var initialState = {
    loadingPermission: false,
    loadingPermissionError: false,
    updatingPermission: false,
    updatePermissionError: false,
    loadingUser: false,
    loadingUserError: false,
    updatingUser: false,
    updateUserError: false,
    user: {},
    meta: {},
    permissions: {},
    formattedPermissions: {},
};
function viewOrganizationPageReducer(currentState, action) {
    if (currentState === void 0) { currentState = initialState; }
    return produce(currentState, function (state) {
        switch (action.type) {
            case LOAD_PERMISSIONS_REQUEST:
                state.loadingPermission = true;
                state.loadingPermissionError = false;
                break;
            case LOAD_PERMISSIONS_SUCCESS:
                state.loadingPermission = false;
                state.loadingPermissionError = false;
                state.permissions = action.permissions;
                break;
            case LOAD_PERMISSIONS_FAILURE:
                state.loadingPermission = false;
                state.loadingPermissionError = true;
                break;
            case UPDATE_PERMISSIONS_REQUEST:
                state.updatingPermission = true;
                state.updatePermissionError = false;
                break;
            case UPDATE_PERMISSIONS_SUCCESS:
                state.updatingPermission = false;
                state.updatePermissionError = false;
                state.permissions = action.permissions;
                break;
            case UPDATE_PERMISSIONS_FAILURE:
                state.loadingPermission = false;
                state.loadingPermissionError = true;
                break;
            case LOAD_USER_REQUEST:
                state.loadingUser = true;
                state.loadingUserError = false;
                break;
            case LOAD_USER_SUCCESS:
                state.loadingUser = false;
                state.loadingUserError = false;
                state.user = action.user;
                state.meta = action.meta;
                break;
            case LOAD_USER_FAILURE:
                state.loadingUser = false;
                state.loadingUserError = true;
                break;
            case UPDATE_USER_REQUEST:
                state.updatingUser = true;
                state.updateUserError = false;
                break;
            case UPDATE_USER_SUCCESS:
                state.updatingUser = false;
                state.updateUserError = false;
                state.user = action.user;
                break;
            case UPDATE_USER_FAILURE:
                state.updatingUser = false;
                state.updateUserError = true;
                break;
            case UPDATE_USER_FIRST_NAME:
                state.user.name = action.firstName;
                break;
            case UPDATE_USER_LAST_NAME:
                state.user.meta.last_name = action.lastName;
                break;
            default:
                break;
        }
    });
}
export default viewOrganizationPageReducer;
